/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import type CompoundQuestion from 'parog-web/models/compound-question';
import BasicRadioGroup, {
  type Signature as BasicRadioGroupSig
} from 'ui-kit/components/changeset/basic-radio-group';

interface S {
  Args: Pick<BasicRadioGroupSig['Args'], 'changeset'> & {
    question: CompoundQuestion;
  };
}

export default <template>
  <div class='field' data-test-question={{@question.id}}>
    <BasicRadioGroup
      @title={{@question.label}}
      @changeset={{@changeset}}
      @propertyName={{concat 'answers.' @question.id}}
      as |Group|
    >
      {{#each @question.answers as |answer index|}}
        <div>
          {{! @glint-expect-error }}
          <Group.Radio @value={{index}} @label={{answer}} />
        </div>
      {{/each}}
    </BasicRadioGroup>
  </div>
</template> satisfies TOC<S>;
